module.exports = {
  footerText: "Copyright LeadUpp © 2025",
};
